import { render, staticRenderFns } from "./Lavorazioni.vue?vue&type=template&id=b4539bd8&scoped=true"
import script from "./Lavorazioni.vue?vue&type=script&lang=ts"
export * from "./Lavorazioni.vue?vue&type=script&lang=ts"
import style0 from "./Lavorazioni.vue?vue&type=style&index=0&id=b4539bd8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4539bd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4539bd8')) {
      api.createRecord('b4539bd8', component.options)
    } else {
      api.reload('b4539bd8', component.options)
    }
    module.hot.accept("./Lavorazioni.vue?vue&type=template&id=b4539bd8&scoped=true", function () {
      api.rerender('b4539bd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Lavorazioni.vue"
export default component.exports